module.exports = __webpack_public_path__ + "img/agrbg.06e5151d.webp";